module.exports = __webpack_public_path__ + "static/Rich Guastadisegni-32c71f62a4c50063f070ff0cc51462e8.png";